export const UPDATE_DOMAIN_NAME = ' UPDATE_DOMAIN_NAME';
export const REMOVE_DOMAIN_NAME = 'REMOVE_DOMAIN_NAME';
export const CLEAR_STATE = 'CLEAR_STATE';
export const UPDATE_USERS = 'UPDATE_USERS';
export const REMOVE_USER = 'REMOVE_USER';
export const SET_DUPLICATE_VALIDATION = 'SET_DUPLICATE_VALIDATION';
export const UPDATE_VIEWS = 'UPDATE_VIEWS';
export const SET_USER_EMPTY = 'SET_USER_EMPTY';
export const SET_DOMAIN_EMPTY = 'SET_DOMAIN_EMPTY';
export const SET_GROUP_STATE = 'SET_GROUP_STATE';
export const SET_VALID_INVALID_DOMAIN_DATA = 'SET_VALID_INVALID_DOMAIN_DATA';
